<template>
  <v-text-field
    @input="handleVisitorBirthDate"
    :label="$t('appointment.formCreate.labels.visitorBirthDate')"
    :hint="$t('forms.dateHint')"
    :rules="rules"
    v-mask="'##/##/####'"
    outlined
  />
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'VisitorBirthDate',

  props: {
    rules: {
      type: Array,
    },
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),

    handleVisitorBirthDate(date) {
      if (date) {
        const splittedDate = date.split('/')
        const parsedDate = `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`
        this.setAppointmentFields({ visitor_birth_date: parsedDate + 'T12:00:00-03:00' })
      } else {
        this.setAppointmentFields({ visitor_birth_date: '' })
      }
    },
  },
}
</script>
